"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateConfigShape = void 0;
const toolbox_1 = require("@streem/toolbox");
// TODO it would be good to support validating the value type
function validateConfigShape(requiredKeys, config) {
    (0, toolbox_1.invariant)(typeof config === 'object', 'config should be object');
    const missingKeys = [];
    requiredKeys.forEach(key => {
        if (!Object.prototype.hasOwnProperty.call(config, key)) {
            missingKeys.push(key);
        }
    });
    if (missingKeys.length) {
        throw new Error(`Missing required key${missingKeys.length > 1 ? 's' : ''}: ${missingKeys.join(', ')}`);
    }
}
exports.validateConfigShape = validateConfigShape;
//# sourceMappingURL=validate_config_shape.js.map